import { Grid } from "@mui/material";
import MakePaymentTable from "../../../components/Dashboard/MakePayment/MakePaymentTable";

const QualificationDetails = (_props) => {
    const { candidateData, className } = _props
    return (
        <fieldset className={`${className}--fieldset`}>
            <legend className={`${className}--legend`}>
                Educational Qualifications Details
            </legend>
            {/* for web preview */}
            <div className="print-web">
                <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <MakePaymentTable
                            data={candidateData?.educationDetails}
                        />
                    </Grid>
                </Grid>
            </div>
            {/* for print preview */}
            <div className="print-view">
                <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className={`${className}--table`}>
                            <MakePaymentTable
                                data={candidateData?.educationDetails}
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        </fieldset>
    )
}

export default QualificationDetails;